import { generatePath } from 'react-router-dom';

export enum NestedRoutes {
  List = 'list',
  Edit = 'edit/:id',
  Create = 'create',
  AddUsers = 'add-users/:id',
  ManageUsers = 'manage-users/:id',
}

const generateInnerPath = (path: string, id: string) => generatePath(path, { id });

export const getEditPath = (rootPath: string, id: string): string =>
  generateInnerPath(`${rootPath}/${NestedRoutes.Edit}`, id);

export const getCreatePath = (rootPath: string): string => `${rootPath}/${NestedRoutes.Create}`;
export const getManageUsersPath = (rootPath: string, id: string): string =>
  generateInnerPath(`${rootPath}/${NestedRoutes.ManageUsers}`, id);
export const getAddUserPath = (rootPath: string, id: string): string =>
  generateInnerPath(`${rootPath}/${NestedRoutes.AddUsers}`, id);
